interface Order {
  id: string;
  status: OrderStatus;
  realizationDate: Date;
  dueDateChanged: Date;
  loadingLocation: string;
  unloadingLocation: string;
  hd: string;
  ms: string;
  transport: string;
  cargoId: string;
  price: number;
  weight: number;
  plannedWeight: number;
  distance: number;
  deletedAt: Date | null;
  createdAt: Date;
  updatedAt: Date;
}

interface MetaType {
  currentPage: number;
  firstPage: number;
  firstPageUrl: string;
  lastPage: number;
  lastPageUrl: string;
  nextPageUrl: string | null;
  perPage: number;
  previousPageUrl: string | null;
  total: number;
}

export enum OrderStatus {
  NowaProsba = "nowywysłana prośba do przewoźnika",
  PrzedstawionePrzewoznikom24h = "przedstawiony Przewoźnikom>=24h",
  PrzedstawionePrzewoznikomNaDzisiaj = "przedstawiony Przewoźnikomna dziś",
  Podjete = "podjęte",
  PrzekazaneDoWysylki = "przekazane do Wysyłki",
  Awizowane = "awizowany",
  DoZaksiegowaniaSAP = "do zaksięgowania w SAP",
  Zaksiegowane = "zaksięgowane w SAP",
  Anulowane = "anulowane",
}

export type { Order, MetaType };
